import moment from 'moment';

import { INotifications } from '../../../../types/responses/Notifications';
import { ITransaction } from '../../../../types/responses/Transactions';
import { parseNotificationMessageType } from '../../../../utils/normalizers/notificationMessageType';

type Return =
  | undefined
  | {
      type: string;
      title: string;
      message: string;
    }[];

type ParseAndFilterStations = (notifications: INotifications[]) => Return;

export const parseAndFilterStations: ParseAndFilterStations = (notifications) => {
  return notifications
    ?.filter(
      (value, index, self) =>
        index ===
        self.findIndex((n) => n?.type === value?.type && n?.notificationTimestampDT === value?.notificationTimestampDT),
    )
    ?.map((nots) => {
      return {
        type: nots?.type,
        title: moment.utc(nots?.notificationTimestampDT).local().format('DD/MM/YYYY HH:mm:ss'),
        message: parseNotificationMessageType(nots?.type),
      };
    });
};

export type ParseTransactionsCardList =
  | undefined
  | {
      energyHumanReadable: string;
      durationTime: string;
      incomeHumanReadable: string;
    }[];

export const parseTransactionsCardList = (list: ITransaction[]): ParseTransactionsCardList => {
  return (
    list &&
    list.map(({ energyHumanReadable, durationTime, incomeHumanReadable }) => ({
      energyHumanReadable,
      durationTime,
      incomeHumanReadable,
    }))
  );
};

export const getFilteredNoti = (list, chargeBoxId) => {
  const data =
    list && chargeBoxId && list.filter((noti) => noti.chargeBoxId === chargeBoxId).map((noti) => noti.notifications);

  return parseAndFilterStations(data?.[0]);
};
